import styled from 'styled-components'

import { IconArrow } from '@avantstay/backoffice-vectors'

import {
  _2XL_Bold,
  _2XL_Light,
  _3XS_Medium,
  _4XL_Bold,
  _4XL_Light,
  _M_Medium,
  _S_Medium,
  mainColors,
  medias,
  semanticColors,
} from '../../styles'

export const IndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  outline: none;

  > div {
    display: flex;
    align-items: center;
  }
`

const getVariationColor = ({ $scale }: { $scale: number }) =>
  $scale > 0 ? semanticColors.successMedium : semanticColors.failureMedium

interface VariationArrowProps {
  $scale: number
  color?: string
}

export const VariationArrow = styled(IconArrow)<VariationArrowProps>`
  ${({ $scale }) =>
    $scale &&
    `
    display: ${$scale ? 'block' : 'none'};

    @supports (content-visibility: hidden) {
      content-visibility: ${$scale ? 'visible' : 'hidden'};
    }
  `}
  color: ${({ color, $scale }) => (color ? color : getVariationColor({ $scale }))};
  ${({ $scale }) => ($scale > 0 ? '' : 'transform: scaleY(-1);')};
`

export const VariationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const VariationValue = styled.div<VariationArrowProps>`
  ${_S_Medium};
  color: ${({ color, $scale }) => (color ? color : getVariationColor({ $scale }))};
  display: flex;
  align-items: center;
  line-height: 20px;

  ${medias.MD_SCREEN`
    ${_M_Medium};
  `}
`

export const VariationPeriod = styled.div`
  ${_3XS_Medium};
  line-height: 11px;
  color: ${mainColors.neutralDark};
`

interface CurrentValueProps {
  color?: string
  bold?: boolean
}

export const CurrentValue = styled.h3<CurrentValueProps>`
  ${({ bold }) => (bold ? _2XL_Bold : _2XL_Light)};
  line-height: 30px;
  color: ${({ color }) => color || mainColors.black};

  ${({ bold }) => medias.MD_SCREEN`
    ${bold ? _4XL_Bold : _4XL_Light};
  `}
`

export const NA = styled.div`
  color: ${mainColors.black};
  font-weight: 100;
`
